// 职业规划
import React from 'react'

import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';

import { checkLogin } from '../../pages/com/utils';

let filePath = Config.getFilePath();

class CareerPlanning extends React.Component 
{
    constructor( props )
    {
        super(props);

        this.state = {
            sourcePath: Config.getSourcePath(),

            data:[
                {id:1, type:"AI人工智能", title:"人工智能带给职场人的便捷，我们如何应对？"},
                {id:2, type:"大学生就业", title:"第二届全国大学生职业规划大赛来了！速来获取职业规划资源~"},
                {id:3, type:"大学生创业", title:"面对职场竞争力，很多毕业大学生选择创业，成本估算较低的情况下......"},
                {id:4, type:"国企实习就业", title:"“如果有机会留下来，你愿意吗？”面对实习单位老师抛出的橄榄枝，张佳乐笑了......"},
                {id:5, type:"求职信息", title:"为什么您总是写不好自己的简历？"},
            ]  
        }
    }

    notify = ( type) => {

        

        switch( type )
        {
            case "planning":
            {
                if( checkLogin() ) 
                {
                    this.props.history.push({pathname:"/home/career-explore"})
                }
                else
                {
                    this.props.history.push({pathname:"/login?redirectURL=/home/career-explore"});
                    window.location.reload(); 
                }
                
                break;
            }
            case "explore":
            {
                if( checkLogin() ) 
                {
                    this.props.history.push({pathname:"/home/career-seek"})
                }
                else
                {
                    this.props.history.push({pathname:"/login?redirectURL=/home/career-seek"});
                    window.location.reload(); 
                }
                
                break;
            }
        }
    }

    render()
    {
        const {sourcePath, data } = this.state;

         return (
            <div className="sf-page" component-data="career-planning">
                <div className='sf-career-top'>
                    <div className='sf-career-top-body'>
                        <div className='sf-career-top-body-content'>
                            <div className='sf-career-top-body-content-entrance'>
                                <div className='sf-career-top-body-item'>
                                    <img src={require('./../../img/' + sourcePath + '/career/tag.png')}></img>
                                    <div className='sf-page-title-font'>聘准准 — 职业探索之路</div>
                                </div>
                                <div className='sf-career-top-body-item sf-second'>
                                    <div className='sf-page-title-font'>您专业的“AI职业规划师”</div>
                                    <img src={require('./../../img/' + sourcePath + '/career/target.png')}></img>
                                </div>

                                <div className='sf-button-bg'>
                                    <div className='sf-career-top-body-start-button sf-start-button' onClick={() => {this.notify("planning")}}>快速开始</div>
                                </div>
                            </div>

                            <div className='sf-career-top-body-right'>
                                <img src={require('./../../img/' + sourcePath + '/career/bg-left.png')} alt=""></img>
                            </div>
                        </div>

                        <div className='sf-career-top-body-content-classify'>
                            <div className="sf-career-explore">
                                <div className='sf-title'>职业探索</div>
                                <div className='sf-content-font'>
                                    <p>如何识别和选择探索更深层次的职位？</p> 
                                    <p>如何制定长期职业规划？</p>
                                    <p>如何保持动力并克服挑战？</p>
                                    <div className='sf-content-font-operation'>
                                        <p>快啦职业树一探究竟！</p><div className='sf-career-explore-button' onClick={() => {this.notify("explore")}} >&nbsp;&nbsp;去探索</div>
                                    </div> 
                                </div>
                            </div>

                            <div className="sf-career-evaluation">
                                <div className='sf-career-evaluation-title-box'>
                                    <div className='sf-career-evaluation-title sf-font'>
                                        <div>职业测评</div>
                                    </div>
                                </div>
                                <div className='sf-career-evaluation-body'>
                                    <p>结合自身情况制定的职业方向</p>
                                    <p>运用科学工具</p>
                                    <p>照亮职业探索之路！</p>
                                </div>
                            </div>

                            <div className="sf-career-tree">
                                <div className='sf-career-tree-title-box'>
                                    <div className='sf-career-tree-title' >
                                        <div>职业技能树</div>
                                    </div>
                                </div>
                               
                                <div className='sf-career-tree-body' >
                                    <p>不同阶层不同的专业技能</p>
                                    <p>看看那您都会哪些？</p>
                                    <p>还需要需要提升哪些技能吧！</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='sf-career-bottom'>
                    
                    <div className='sf-career-vide-box'>
                        <div className='sf-career-video'>
                            <div className='sf-career-video-title-box'>
                                <div className='sf-career-video-title' >
                                    <div>职业微视</div>
                                </div>
                            </div>
                            
                            <div className='sf-career-video-body' >
                                <p>前人栽树，后人乘凉</p>
                                <p>职场未来不迷路！</p>
                            </div>
                        </div>
                       
                        <img src={require("./../../img/" + sourcePath +"/career/career-video-bg.png")} alt=""></img>
                    </div>

                    <div className='sf-career-info'>
                        <div className='sf-career-title'>
                            <div className='sf-career-title-item'>
                                <img src={require("./../../img/" + sourcePath +"/career/career-info-title.png")} alt=""></img>
                                <span>职业资讯</span>
                            </div>
                            <div className='sf-click'>
                                更多 &gt;&gt;
                            </div>
                        </div>
                        <div className='sf-career-info-body'>
                        {
                            data.map((item, index) => {
                                return (
                                    <div className='sf-career-info-item' key={ index + "_" + item.id}>
                                        <div className='sf-career-info-type'>【{item.type}】</div>
                                        <div className='sf-career-info-content'>{item.title}</div>
                                    </div>
                                )
                            })
                        }
                        </div>
                        <img src={require("./../../img/" + sourcePath +"/career/career-info-icon.png")} alt=""/>
                    </div>
                </div>  

            </div> 
        )
    }
}

export default CareerPlanning